import {
  EDITOR_FETCH_PAGE_DETAIL_BEGIN,
  EDITOR_FETCH_PAGE_DETAIL_SUCCESS,
  EDITOR_FETCH_PAGE_DETAIL_FAILURE,
  EDITOR_FETCH_PAGE_DETAIL_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function fetchPageDetail(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EDITOR_FETCH_PAGE_DETAIL_BEGIN,
    });
    const { projectId, version, currentPageId, pageId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const newPageId = currentPageId ? currentPageId : pageId;
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/pages/${newPageId}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EDITOR_FETCH_PAGE_DETAIL_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EDITOR_FETCH_PAGE_DETAIL_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchPageDetailError() {
  return {
    type: EDITOR_FETCH_PAGE_DETAIL_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_FETCH_PAGE_DETAIL_BEGIN:
      return {
        ...state,
        fetchPageDetailPending: true,
        fetchPageDetailError: null,
      };

    case EDITOR_FETCH_PAGE_DETAIL_SUCCESS:
      // The request is success
      return {
        ...state,
        fetchPageDetailPending: false,
        fetchPageDetailError: null,
        pageDetail: action.data,
      };

    case EDITOR_FETCH_PAGE_DETAIL_FAILURE:
      return {
        ...state,
        fetchPageDetailPending: false,
        fetchPageDetailError: action.data.error,
      };

    case EDITOR_FETCH_PAGE_DETAIL_DISMISS_ERROR:
      return {
        ...state,
        fetchPageDetailError: null,
      };

    default:
      return state;
  }
}
